/**
 * Rappel de la configuration en cours, affiche au-dessus du visuel produit.
 *
 * Le composant ne connait pas les variantes : il relit simplement les radios
 * cochees du configurateur de sa section et les joint par « · ». La source de
 * verite reste donc VariantSelects, et aucune logique de variante n'est
 * dupliquee ici.
 *
 * L'ecoute se fait au niveau du document : le <variant-selects> est remplace a
 * chaque changement par la Section Rendering API, un ecouteur pose dessus ne
 * survivrait pas au premier clic.
 */
class GoConfigSummary extends HTMLElement {
  connectedCallback() {
    this.onChange = this.onChange.bind(this);
    document.addEventListener('change', this.onChange);
    this.sync();
  }

  disconnectedCallback() {
    document.removeEventListener('change', this.onChange);
  }

  get selector() {
    return `variant-selects[data-section="${this.dataset.section}"]`;
  }

  onChange(event) {
    if (!event.target.closest?.(this.selector)) return;
    this.sync();
  }

  sync() {
    const source = document.querySelector(this.selector);
    if (!source) return;

    const text = Array.from(source.querySelectorAll('fieldset input:checked'))
      .map((input) => input.value)
      .join(' · ');

    // Une configuration vide n'existe pas : si la lecture ne donne rien, c'est
    // que le DOM est en cours de remplacement. On garde alors l'ancien texte
    // plutot que d'afficher un blanc le temps du re-rendu.
    if (!text || text === this.textContent) return;

    this.textContent = text;
  }
}

// Meme garde que les autres composants GO! : `featured-product` est une
// section repetable, et deux balises <script src> identiques s'executent deux
// fois sur la meme page.
if (!customElements.get('go-config-summary')) {
  customElements.define('go-config-summary', GoConfigSummary);
}
